import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Layout } from '../components/Layout';
import { toast } from 'sonner';
import DashboardBuilder from '../components/dashboard/DashboardBuilder';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const Dashboard = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch basic stats to verify API is working
    const fetchDashboardStats = async () => {
      try {
        await axios.get(`${API}/dashboard/stats`);
      } catch (error) {
        console.error('Failed to fetch dashboard stats:', error);
        // Don't show error toast - DashboardBuilder will handle its own data
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardStats();
  }, []);

  if (loading) {
    return (
      <Layout>
        <div className="flex items-center justify-center h-96">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto"></div>
            <p className="mt-4 text-muted-foreground">Loading dashboard...</p>
          </div>
        </div>
      </Layout>
    );
  }

  // Use DashboardBuilder for all users - provides a consistent, customizable experience
  return (
    <Layout>
      <div className="space-y-6" data-testid="dashboard-builder-container">
        <DashboardBuilder />
      </div>
    </Layout>
  );
};

export default Dashboard;
